module.exports = __webpack_public_path__ + "img/ideathree.7e625f61.png";